

























import UserRequired from "../UserRequired";
import {Component, Prop, Watch} from "vue-property-decorator";
import {NotificationConfig, WeekDays, WhenType, whenTypeToText} from "@/modules/notificationmodels";

@Component
export default class NotificationConfigWhenEdit extends UserRequired {
  @Prop()
  config!: NotificationConfig;

  @Prop({default: false})
  value!: boolean;

  get opened() {
    return this.value;
  }
  set opened(v: boolean) {
    this.$emit("input", v);
  }

  // Need a copy of prop to mutate locally before propagating it through save emit
  editConfig: NotificationConfig = this.config;

  // Remove weekday when interval is changed from weekly to not weekly
  @Watch("editConfig", {deep: true})
  onEditConfigChange() {
    if(this.editConfig.whenType != this.whenTypeWeekly) {
      this.editConfig.whenWeekday = null;
    }
  }

  readonly whenTypeWeekly = WhenType.Weekly;

  get whenTypeListing() {
    return [
      {text: whenTypeToText(WhenType.Weekly), value: WhenType.Weekly},
      {text: whenTypeToText(WhenType.Daily), value: WhenType.Daily},
    ]
  }

  get whenWeekdayListing() {
    return [
      {text: "Mandag", value: WeekDays.Mon},
      {text: "Tirsdag", value: WeekDays.Tue},
      {text: "Onsdag", value: WeekDays.Wed},
      {text: "Torsdag", value: WeekDays.Thu},
      {text: "Fredag", value: WeekDays.Fri},
      {text: "Lørdag", value: WeekDays.Sat},
      {text: "Søndag", value: WeekDays.Sun},
    ];
  }

  hourFormatted(h: number) {
    return String(h).padStart(2, "0");
  }

  get whenHourListing() {
    const ret: any[] = [];
    for(let h = 0; h < 24; h++) {
      const hStr = this.hourFormatted(h);
      ret.push({text: `Kl ${hStr}:00`, value: h});
    }
    return ret;
  }

  emitSave() {
    this.$emit("at-notif-config-do-save", this.editConfig);
  }
}
